import React from 'react'
import './TitleNames.css'
import logo from '../../Assets/Logo-pal.png'
import hometitl from '../../Assets/hometitl.svg'
import notify from '../../Assets/bellnotify.svg'
import { Link, useNavigate } from 'react-router-dom'
import Dashboard from '../../Pages/Dashboard/Dashboard'
import user from '../../Assets/userimg.png'

const TitleNames = () => {
const navigate = useNavigate()
    const homepageURL = JSON.parse(sessionStorage.getItem("login_details"))
    const handleLogOut = (e) => {
        e.preventDefault();
        sessionStorage.clear();
        navigate("/");
    };
    return (
        <>

            <nav className="navbar navbar-expand-lg navbar-light bg-light HeadNavContent">

                <div className=''><img className='MainLoho' src={logo} /></div>
                <div className="collapse navbar-collapse ContendEnd" id="navbarSupportedContent">

                    <form className="form-inline my-2 my-lg-0 ">
                    <Link to="/dashboard">  <div><img className='HeaderLogoimg' alt='' src={hometitl} /></div></Link>
                        <div><img className='BellNotify' alt='' src={notify} /></div>
                      



                        <Link >  <div class="dropdown"><img className='ProfileImg' id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" alt='Profile' src={homepageURL?.user_image !== '' ? homepageURL?.user_image : user} style={{ height: "50px", width: "50px" }} />
                            {/* <button class="btn btn-secondary dropdown-toggle" type="button">
                                Dropdown button
                            </button> */}
                            <div class="dropdown-menu Logout" aria-labelledby="dropdownMenuButton" onClick={handleLogOut}>
                                <a class="dropdown-item" href="#">Logout</a>
                            </div>
                        </div></Link>



                        {/* <div className='BelandNotictio'>
                         
                            <div><p className='PtagcssTitlesv'>Notification</p></div>
                        </div> */}



                        {/* <div className='ComonCss'>
                         

                            <div>
                                <p className='PtagcssTitle'>Name</p>
                                <p className='PtagcssTitles'>View Profile</p>
                            </div>
                        </div> */}


                    </form>
                </div>
            </nav>
            {/* <div classNameName=''>
                <div classNameName='row HeaderNames'>
                    <div classNameName='col-lg-6 col-md-6 col-sm-6 col-6 HeaderTitle'>
                        
                        <div className='LogofIsrt'><img className='MainLoho' src={logo} /></div>
                    </div>
                    
                    <div className='col-lg-4 col-md-4 col-sm-4 col-4 HedrContent'>
                        <div><img className='HeaderLogoimg'alt='' src={hometitl} /></div>

                        <div>
                            <div><img className='BellNotify'alt='' src={notify} /></div>
                            <div><p className='PtagcssTitlesv'>Notification</p></div>
                        </div>

                        <div className='ComonCss'>
                            <div><img className='ProfileImg' alt='' src={hometitl} /></div>
                            <div>
                                <p className='PtagcssTitle'>Name</p>
                                <p className='PtagcssTitles'>View Profile</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div> */}

        </>
    )
}

export default TitleNames